// Clickable table header that cycles sort direction (asc → desc → off).
// Used by the Downloads analytics table. Keeps parent-owned state so the
// same `sortConfig` can also drive the row sorter.
//
// Usage:
//   <SortableTH field="created_at" sortConfig={sort} onSort={setSort}>
//     When
//   </SortableTH>

import { CaretUp, CaretDown, CaretUpDown } from "@phosphor-icons/react";

export default function SortableTH({ field, sortConfig, onSort, children, className = "" }) {
  const isActive = sortConfig?.field === field;
  const dir = isActive ? sortConfig.direction : null;

  const cycle = () => {
    if (!isActive) return onSort({ field, direction: "asc" });
    if (dir === "asc") return onSort({ field, direction: "desc" });
    return onSort(null); // clear sort
  };

  const Icon = !isActive ? CaretUpDown : dir === "asc" ? CaretUp : CaretDown;

  return (
    <th className={`p-3 ${className}`}>
      <button
        type="button"
        onClick={cycle}
        className={`inline-flex items-center gap-1 font-mono uppercase tracking-widest text-[11px] hover:text-neutral-900 ${
          isActive ? "text-neutral-900" : "text-neutral-500"
        }`}
        data-testid={`sort-th-${field}`}
        aria-sort={isActive ? (dir === "asc" ? "ascending" : "descending") : "none"}
      >
        <span>{children}</span>
        <Icon size={10} weight="bold" className={isActive ? "opacity-100" : "opacity-50"} />
      </button>
    </th>
  );
}
